import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/app/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Bytes } from '@polkadot/types-codec';
import { assert, isFunction, isString, isU8a } from '@polkadot/util';
import { getSiName } from "../metadata/util/index.js"; // hasher type -> [initialHashLength, canDecodeKey]

var HASHER_MAP = {
  // opaque
  Blake2_128: [16, false],
  // eslint-disable-line camelcase
  Blake2_128Concat: [16, true],
  // eslint-disable-line camelcase
  Blake2_256: [32, false],
  // eslint-disable-line camelcase
  Identity: [0, true],
  Twox128: [16, false],
  Twox256: [32, false],
  Twox64Concat: [8, true]
};
export function unwrapStorageSi(type) {
  return type.isPlain ? type.asPlain : type.asMap.value;
}
/** @internal */

export function unwrapStorageType(registry, type, isOptional) {
  var outputType = getSiName(registry.lookup, unwrapStorageSi(type));
  return isOptional ? "Option<".concat(outputType, ">") : outputType;
}
/** @internal */

function decodeStorageKey(value) {
  if (isU8a(value) || !value || isString(value)) {
    // let Bytes handle these inputs
    return {
      key: value
    };
  } else if (value instanceof StorageKey) {
    return {
      key: value,
      method: value.method,
      section: value.section
    };
  } else if (isFunction(value)) {
    return {
      key: value(),
      method: value.method,
      section: value.section
    };
  } else if (Array.isArray(value)) {
    var _value = _slicedToArray(value, 2),
        fn = _value[0],
        _value$ = _value[1],
        args = _value$ === void 0 ? [] : _value$;

    assert(isFunction(fn), 'Expected function input for key construction');

    if (fn.meta && fn.meta.type.isMap) {
      var map = fn.meta.type.asMap;
      assert(Array.isArray(args) && args.length === map.hashers.length, function () {
        return "Expected an array of ".concat(map.hashers.length, " values as params to a Map query");
      });
    }

    return {
      key: fn.apply(void 0, _toConsumableArray(args)),
      method: fn.method,
      section: fn.section
    };
  }

  throw new Error("Unable to convert input ".concat(value, " to StorageKey"));
}
/** @internal */


function decodeHashers(registry, value, hashers) {
  // the storage entry is xxhashAsU8a(prefix, 128) + xxhashAsU8a(method, 128), 256 bits total
  var offset = 32;
  var result = new Array(hashers.length);

  for (var i = 0; i < hashers.length; i++) {
    var _hashers$i = _slicedToArray(hashers[i], 2),
        hasher = _hashers$i[0],
        type = _hashers$i[1];

    var _HASHER_MAP$hasher$ty = _slicedToArray(HASHER_MAP[hasher.type], 2),
        hashLen = _HASHER_MAP$hasher$ty[0],
        canDecode = _HASHER_MAP$hasher$ty[1];

    var decoded = canDecode ? registry.createTypeUnsafe(getSiName(registry.lookup, type), [value.subarray(offset + hashLen)]) : registry.createTypeUnsafe('Raw', [value.subarray(offset, offset + hashLen)]);
    offset += hashLen + (canDecode ? decoded.encodedLength : 0);
    result[i] = decoded;
  }

  return result;
}
/** @internal */


function decodeArgsFromMeta(registry, value, meta) {
  if (!meta || !meta.type.isMap) {
    return [];
  }

  var _meta$type$asMap = meta.type.asMap,
      hashers = _meta$type$asMap.hashers,
      key = _meta$type$asMap.key;
  var keys = hashers.length === 1 ? [key] : registry.lookup.getSiType(key).def.asTuple;
  return decodeHashers(registry, value, hashers.map(function (h, i) {
    return [h, keys[i]];
  }));
}
/** @internal */


function getMeta(value) {
  if (value instanceof StorageKey) {
    return value.meta;
  } else if (isFunction(value)) {
    return value.meta;
  } else if (Array.isArray(value)) {
    var _value2 = _slicedToArray(value, 1),
        fn = _value2[0];

    return fn.meta;
  }

  return undefined;
}
/** @internal */


function getType(registry, value) {
  if (value instanceof StorageKey) {
    return value.outputType;
  } else if (isFunction(value)) {
    return unwrapStorageType(registry, value.meta.type);
  } else if (Array.isArray(value)) {
    var _value3 = _slicedToArray(value, 1),
        fn = _value3[0];

    if (fn.meta) {
      return unwrapStorageType(registry, fn.meta.type);
    }
  } // If we have no type set, default to Raw


  return 'Raw';
}
/**
 * @name StorageKey
 * @description
 * A representation of a storage key (typically hashed) in the system. It can be
 * constructed by passing in a raw key or a StorageEntry with (optional) arguments.
 */


var _args = /*#__PURE__*/new WeakMap();

var _meta = /*#__PURE__*/new WeakMap();

var _outputType = /*#__PURE__*/new WeakMap();

var _method = /*#__PURE__*/new WeakMap();

var _section = /*#__PURE__*/new WeakMap();

export var StorageKey = /*#__PURE__*/function (_Bytes) {
  _inherits(StorageKey, _Bytes);

  var _super = _createSuper(StorageKey);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore This is assigned via this.decodeArgsFromMeta()
  function StorageKey(registry, value) {
    var _this;

    var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, StorageKey);

    var _decodeStorageKey = decodeStorageKey(value),
        key = _decodeStorageKey.key,
        method = _decodeStorageKey.method,
        section = _decodeStorageKey.section;

    _this = _super.call(this, registry, key);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _args, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _meta, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _outputType, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _method, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _section, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_assertThisInitialized(_this), _outputType, getType(registry, value)); // decode the args (as applicable based on the key and the hashers, after all init)


    _this.setMeta(getMeta(value), override.section || section, override.method || method);

    return _this;
  }
  /**
   * @description Return the decoded arguments (applicable to map with decodable values)
   */


  _createClass(StorageKey, [{
    key: "args",
    get: function get() {
      return _classPrivateFieldGet(this, _args);
    }
    /**
     * @description The metadata or `undefined` when not available
     */

  }, {
    key: "meta",
    get: function get() {
      return _classPrivateFieldGet(this, _meta);
    }
    /**
     * @description The key method or `undefined` when not specified
     */

  }, {
    key: "method",
    get: function get() {
      return _classPrivateFieldGet(this, _method);
    }
    /**
     * @description The output type
     */

  }, {
    key: "outputType",
    get: function get() {
      return _classPrivateFieldGet(this, _outputType);
    }
    /**
     * @description The key section or `undefined` when not specified
     */

  }, {
    key: "section",
    get: function get() {
      return _classPrivateFieldGet(this, _section);
    }
  }, {
    key: "is",
    value: function is(key) {
      return key.section === this.section && key.method === this.method;
    }
    /**
     * @description Sets the meta for this key
     */

  }, {
    key: "setMeta",
    value: function setMeta(meta, section, method) {
      _classPrivateFieldSet(this, _meta, meta);

      _classPrivateFieldSet(this, _method, method || _classPrivateFieldGet(this, _method));

      _classPrivateFieldSet(this, _section, section || _classPrivateFieldGet(this, _section));

      if (meta) {
        _classPrivateFieldSet(this, _outputType, unwrapStorageType(this.registry, meta.type));
      }

      try {
        _classPrivateFieldSet(this, _args, decodeArgsFromMeta(this.registry, this.toU8a(true), meta));
      } catch (error) {// ignore...
      }

      return this;
    }
    /**
     * @description Returns the Human representation for this type
     */

  }, {
    key: "toHuman",
    value: function toHuman() {
      return _classPrivateFieldGet(this, _args).length ? _classPrivateFieldGet(this, _args).map(function (a) {
        return a.toHuman();
      }) : _get(_getPrototypeOf(StorageKey.prototype), "toHuman", this).call(this);
    }
    /**
     * @description Returns the raw type for this
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return 'StorageKey';
    }
  }]);

  return StorageKey;
}(Bytes);